import axios from './axios';
export default {
    get: (url, payload) => axios.get(`${url}${querify(payload)}`),
    post: (url, payload) => axios.post(url, payload)
}

const querify = (params) => {
    if (!params || !Object.keys(params).length) return '';

    const arrParams = [];
    Object.keys(params).map(key => typeof params[key] !== 'undefined' && arrParams.push(`${key}=${params[key]}`));
    const join = !!arrParams.length? '?': '';
    const queryString = join + arrParams.join('&');
    return queryString;
}


// WEBPACK FOOTER //
// ./src/repositories/base2.repository.js